import { Controller } from "@hotwired/stimulus"

// PWAインストールを管理するコントローラー（Chrome等向け）
// beforeinstallpromptイベントを捕捉し、インストールボタンを表示する
// iOS Safariの案内はサーバーサイドで制御
export default class extends Controller {
  static targets = ["button"]

  connect() {
    if (this.isStandalone()) return

    this.deferredPrompt = null

    this.handleBeforeInstallPrompt = (event) => {
      event.preventDefault()
      this.deferredPrompt = event
      if (this.hasButtonTarget) this.buttonTarget.classList.remove("d-none")
    }

    this.handleAppInstalled = () => {
      this.deferredPrompt = null
      if (this.hasButtonTarget) this.buttonTarget.classList.add("d-none")
    }

    window.addEventListener("beforeinstallprompt", this.handleBeforeInstallPrompt)
    window.addEventListener("appinstalled", this.handleAppInstalled)
  }

  disconnect() {
    if (this.handleBeforeInstallPrompt) {
      window.removeEventListener("beforeinstallprompt", this.handleBeforeInstallPrompt)
    }
    if (this.handleAppInstalled) {
      window.removeEventListener("appinstalled", this.handleAppInstalled)
    }
  }

  async install() {
    if (!this.deferredPrompt) return

    this.deferredPrompt.prompt()
    const { outcome } = await this.deferredPrompt.userChoice

    if (outcome === "accepted") {
      this.deferredPrompt = null
      if (this.hasButtonTarget) this.buttonTarget.classList.add("d-none")
    }
  }

  isStandalone() {
    return window.navigator.standalone || window.matchMedia("(display-mode: standalone)").matches
  }
}